<template>
    <div class="widget-inner">
        <template v-if="isPersonalDashboardWidget">
            <div class="widget-empty-message" v-if="!entries.length">
                <div :style="isPersonalDashboardWidget ? {color} : {}">
                    {{widget.emptyMessage}}
                </div>
            </div>
            <div class="widget-content" v-else>
                <div v-for="entry in entries" :class="['flex margin-5', {'bottom-border': entry !== entries[entries.length - 1]}]">
                    <div v-if="entry.icon" class="flex flex-center widget-image-holder">
                        <i class="material-icons" aria-hidden="true" :style="{color: entry.icon.color}" :title="entry.icon.tooltip" role="img">
                            {{entry.icon.icon}}
                        </i>
                    </div>
                    <div class="flex flex-vertical-middle">
                        <router-link v-if="entry.link" :to="entry.link">{{entry.title}}</router-link>
                        <span v-else>{{entry.title}}</span>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="widget-empty-message" v-if="!content.entries.length">
                <i class="material-icons md-96" aria-hidden="true" role="img">{{widget.emptyIcon}}</i>
                <br/>
                {{widget.emptyMessage}}
            </div>
            <ul v-else class="widget-content">
                <li class="flex"
                    :class="{'background-today': isToday(entry.created)}"
                    v-for="entry in content.entries">
                    <div v-if="entry.paths && entry.paths.medium || entry.icon" class="flex flex-center widget-image-holder">
                        <img class="widget-image" :src="entry.paths.medium" v-if="entry.paths && entry.paths.medium" alt="Vorschaubild"/>
                        <i class="material-icons" aria-hidden="true"
                            :style="{color: entry.iconColor && entry.iconColor.startsWith('#') ? entry.iconColor : ('rgb(' + entry.iconColor + ')')}"
                            v-else-if="entry.icon" role="img">{{entry.icon}}</i>
                    </div>
                    <div class="text-overflow">
                        <router-link :to="entry.link" v-if="entry.link">{{entry.title}}</router-link>
                        <router-link v-else :to="{name: widget.viewRoute, params: entry}">{{entry.title}}</router-link>
                        <small>
                            <template v-if="entry.created">
                                {{dateHelper('d.m.Y', entry.created)}}
                            </template>
                            <template v-if="entry.creator">
                                von {{getUsername(entry.creator)}}
                            </template>
                        </small>
                    </div>
                </li>
            </ul>
        </template>
    </div>
</template>

<script lang="ts">
    import PersonBoxEmployee from '@/components/PersonBoxEmployee.vue';
    import {Component} from 'vue-facing-decorator';
    import {State} from 'vuex-facing-decorator';
    import {WidgetDefault} from './WidgetDefault.vue';

    interface IWidgetOpenFeedbackEntry
    {
        title: string,
        resource: string,
        link: string,
        icon: Nullable<{
            icon: string,
            color: string,
            tooltip: string
        }>
    }

    @Component({
        name: 'WidgetOpenFeedback',
        components: {PersonBoxEmployee},
    })
    export class WidgetOpenFeedback extends WidgetDefault
    {
        @State('layoutData') layoutData: LayoutData;

        get entries(): IWidgetOpenFeedbackEntry[]
        {
            return (this.content.entries as IWidgetOpenFeedbackEntry[]).map(entry =>
            {
                let module = this.layoutData.modules.find(module => module.resource === entry.resource);
                if (entry.resource === 'training')
                {
                    module = this.layoutData.modules.find(module => module.resource === 'employee');
                }

                entry.icon = module ? {
                    icon: module.icon,
                    color: '#' + module.color,
                    tooltip: module.name,
                } : null;

                return entry;
            });
        }
    }

    export default WidgetOpenFeedback;
</script>